export enum GenericPopupOperation{
    SendIcWorkflowEmail,
    DeletePortfolioCompany
}